import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { CustomSnackbarService } from '../../../../services/custom-snackbar.service';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-reactivate-user',
  templateUrl: './reactivate-user.component.html',
  styleUrls: ['./reactivate-user.component.scss']
})
export class ReactivateUserComponent {
  userForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ReactivateUserComponent>,
    private builder: FormBuilder,
    private snackBarService: CustomSnackbarService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.userForm = this.builder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  reactivateUser(): void {
    this.userService.reactivateUser(this.userForm.get('email')?.value).subscribe(() => {
      this.snackBarService.present(this.translate.instant('ReactivateUserComponent.reactivatedUser'));
      this.dialogRef.close();
    });
  }
}
